import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/criar-senha.svg'


const _hoisted_1 = { class: "password-view container" }
const _hoisted_2 = { class: "breadcrumb-password-view py-3 row" }
const _hoisted_3 = { class: "wizard-voucher mb-3 row" }
const _hoisted_4 = { class: "content-password-view" }
const _hoisted_5 = { class: "d-flex flex-row row" }
const _hoisted_6 = { class: "col-12 col-md-6" }
const _hoisted_7 = { class: "input-create-password" }
const _hoisted_8 = { class: "d-flex justify-content-end mt-2" }
const _hoisted_9 = { class: "input-confirm-password col-12" }
const _hoisted_10 = { class: "d-flex justify-content-end mt-2 row" }
const _hoisted_11 = { class: "col-xs-12 col-lg-4" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "d-flex flex-row justify-content-end align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Wizzard = _resolveComponent("Wizzard")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Breadcrumb)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Wizzard, { "current-page": "pass" })
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "title-password-view text-start" }, [
      _createElementVNode("h1", null, "Emissão de Certificado")
    ], -1)),
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "description-password-view text-start" }, [
      _createElementVNode("p", null, "Agora você precisa criar sua senha de emissão.")
    ], -1)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "col-12 col-md-6 d-none d-md-block text-start" }, [
          _createElementVNode("img", {
            alt: "emitir-certificado",
            src: _imports_0
          })
        ], -1)),
        _createElementVNode("div", _hoisted_6, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "description-password-view d-flex text-start" }, [
            _createElementVNode("p", null, [
              _createTextVNode(" Sua senha deve ter entre "),
              _createElementVNode("strong", null, "8 e 12 caracteres"),
              _createTextVNode(" , ter pelo menos uma letra "),
              _createElementVNode("strong", null, "maiúscula"),
              _createTextVNode(" e uma letra "),
              _createElementVNode("strong", null, "minúscula"),
              _createTextVNode(" e "),
              _createElementVNode("strong", null, "números"),
              _createTextVNode(". "),
              _createElementVNode("strong", null, "Anote sua senha em um lugar seguro!")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Input, {
              modelValue: _ctx.password,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
              label: "Senha",
              icon: "lock",
              "is-required": true,
              placeholder: "Digite a senha",
              type: "password"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", {
                class: _normalizeClass(["circle", [
                  _ctx.validation.minLength ? 'bg--success' : 'bg--grayscale-light',
                ]])
              }, " +8 ", 2),
              _createElementVNode("span", {
                class: _normalizeClass(["mx-2 circle", [
                  _ctx.validation.uppercase ? 'bg--success' : 'bg--grayscale-light',
                ]])
              }, " A ", 2),
              _createElementVNode("span", {
                class: _normalizeClass(["circle", [
                  _ctx.validation.lowercase ? 'bg--success' : 'bg--grayscale-light',
                ]])
              }, " a ", 2),
              _createElementVNode("span", {
                class: _normalizeClass(["ms-2 circle", [
                  _ctx.validation.hasNumber ? 'bg--success' : 'bg--grayscale-light',
                ]])
              }, " 123 ", 2)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_Input, {
                modelValue: _ctx.confirmPassword,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.confirmPassword) = $event)),
                label: "Confirmação de senha",
                icon: "lock",
                "is-required": true,
                placeholder: "Confirme a senha",
                type: "password",
                "error-log": _ctx.error
              }, null, 8, ["modelValue", "error-log"]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["btn w-100 d-flex justify-content-center align-items-center", !_ctx.isValid ? 'btn-secondary' : 'btn-primary']),
                    type: "button",
                    disabled: !_ctx.isValid,
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.savePassword && _ctx.savePassword(...args)))
                  }, [
                    _createElementVNode("div", _hoisted_13, [
                      _cache[3] || (_cache[3] = _createElementVNode("span", null, "Avançar", -1)),
                      _createVNode(_component_Icon, {
                        name: "arrow-right",
                        class: "ms-2"
                      })
                    ])
                  ], 10, _hoisted_12)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}